import { useEffect } from 'react';
import { resolveAssetUrl } from '@/shop/assetUrl';
import { useSkillSkins } from '@/skills/skillSkinStore';
import type { SkillType } from '@/skills/skillsApi';
import { SkillVortex, SkillShield } from './SkillIcons';

interface Props {
  skill: SkillType;
  size?: number;
}

/**
 * Renders a skill's icon. Prefers the admin-uploaded PNG/WebP skin (global per
 * skill) and falls back to the built-in SVG when none is set. Drop-in
 * replacement for the raw SkillVortex/SkillShield components.
 */
export function SkillIcon({ skill, size = 40 }: Props) {
  const url = useSkillSkins((s) => s.skins[skill]);
  const load = useSkillSkins((s) => s.load);

  useEffect(() => { void load(); }, [load]);

  const resolved = resolveAssetUrl(url);
  if (resolved) {
    return (
      <img
        src={resolved}
        alt={skill}
        width={size}
        height={size}
        draggable={false}
        style={{ width: size, height: size, objectFit: 'contain', display: 'block', pointerEvents: 'none' }}
      />
    );
  }
  return skill === 'disrupt' ? <SkillVortex size={size} /> : <SkillShield size={size} />;
}
